// eslint-disable-next-line @typescript-eslint/no-restricted-imports
import type { InternalAxiosRequestConfig } from 'axios';

import { objectKeysToSnakeCase } from '../utils/objectKeysTo.js';

/**
 * Request interceptor: if config.request.snakeCaseQueryParams is true, convert
 * all keys of config.params to snake_case before axios serializes the URL.
 *
 * The `request` field is populated by our extended `ClientOptions` (from
 * `@mint-lib/api-zod-support`) flat-spread into the axios config via upstream's
 * makeConfig.
 */
export function requestQueryParamsToSnakeCase(
  config: InternalAxiosRequestConfig,
): InternalAxiosRequestConfig {
  const snake = (config as { request?: { snakeCaseQueryParams?: boolean } })
    .request?.snakeCaseQueryParams;
  if (snake && config.params) {
    config.params = objectKeysToSnakeCase(
      config.params as Record<string, unknown>,
    );
  }
  return config;
}
